import styled from 'styled-components';
import {mediaQueries} from '../modules/common';

const Paragraph = styled.p`
    margin: 0 0 8px;
    line-height: 24px;
    ${mediaQueries.lessThan('small')`
        font-size: ${(props): string =>
            `${props.theme.fontSizes.small}${props.theme.unitsOfMeasure.px}`}
    `};
`;

export const TeloaParagraph = styled.p`
    margin: 0 0 8px;
    line-height: 24px;
    ${mediaQueries.lessThan('small')`
        font-size: 16px;
    `};
`;

export default Paragraph;
